import { createSlice } from "@reduxjs/toolkit";
import { WritableDraft } from "immer/dist/internal";
import { setProp } from "Store/Actions";
import { setPropT } from "Store/Actions/ts";
import setObj from "lodash/set";
import { preCiqInformation } from "Pages/pre-ciq-network/Constants/preCiqInformation";
import { access } from "fs";


const initialData = {
    perCiqNetwork: [],
    selectedPreCiqNetwork:{},
    preCiqNetworkPlanLoading: false,
    preCiqElement: [],
    preCiqStepComposite: {},
    mainDivHieght: 0,
    preCiqNetworkStepLoading: false,
    preCiqDataCallbackLoading: false,
    preCiqToast: false,
    locationArea: {},
    high_level_design: false,
    low_level_design: false,
    other_assets: false,
    high_level_design_count: 0,
    low_level_design_count: 0,
    other_assets_count: 0,
    high_level_design_files: [],
    low_level_design_files: [],
    other_assets_files:[],
    prevLat: 0,
    prevLng: 0,
    offerDetails: {},
    errorStepData: {},
    showDialogBox: false,
    tabDetails:{},
    shareDialogStatus: false,
    shareDetails:[],
    internalShare: true,
    accessType: true,
    high_level_design_file_types: {accept: [],count: 1},
    low_level_design_file_types:{accept:[],count: 1},
    other_assets_file_types:{accept:[],count: 1},
    datacallBackStatus: {fieldName: "", status: false},
    shareMessage: "",
    externalUser: {},
    caseOfferDetails: {},
    tabSelected: "sales_to_delivery",
    preCiqInformationData: {},
    expandPanelSTD: "project_details",
    shareAccessStatus: false,
    alertModelData: {},
    salestoDeliveryLoading: false,
    salestoDeliveryAccessData: {readonly: true, singoff: true, projectChecklist: false, singoffField: false},
    handoverConfirmStatus: false,
    panelLoading: false,
    pta_file_types: {accept: [],count: 1},
    snackbarMessage: "",
    signoffApprovaltype: "",
    saveButtonStatus: true,
    buttonStatus: true,
    cpm: false,
    total_rrh_card_pids: {},
    total_capacity_card_pids: {},
    ciqOfferStatus: "",
    editableAccess: true
}

const preCiqNetworkSlice = createSlice({
    name: 'preCiqNetwork',
    initialState: initialData,
    reducers:{
        setPreCiqNetwork(state, action){
            state.perCiqNetwork = action.payload;
        },
        setSelectedPreCiqNetwork(state, action) {
            state.selectedPreCiqNetwork = action.payload
        },
        setPreCiqStepComposite(state, action) {
            state.preCiqStepComposite = action.payload
        }
    },
      extraReducers(builder) {
            builder.addCase(setProp, (state, action: setPropT) => {
                if (action.payload.slice === preCiqNetworkSlice.name) {
                    setObj(state, action.payload.key, action.payload.value);
                }
            })
        }
  
})

export default preCiqNetworkSlice.reducer;
export const {setPreCiqNetwork,setSelectedPreCiqNetwork,setPreCiqStepComposite} = preCiqNetworkSlice.actions;


